module.exports = __webpack_public_path__ + "img/img97.a5917249.svg";